import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { AuthService } from './services/auth.service';

export function provideAuth(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const authService = inject(AuthService);
    return authService.init();
  });
}
